const messages = {
  "Algolia.GlobalSearch.Heading": "Search Results",
  "Algolia.GlobalSearch.TextField.Placeholder": "What you are looking for?",
  "Algolia.GlobalSearch.SearchButton.Text": "Search",
  "Algolia.GlobalSearch.EventType.Label": "Page Type",
  "Algolia.GlobalSearch.ItemsPerPage.Label": "Items Per Page",
  "Algolia.GlobalSearch.Meta.Text": "{count} Search Results",

  "Algolia.SearchPage.Heading": "Find Your Study Abroad Program",
  "Algolia.SearchPage.TextField.Placeholder": "Search programs by keyword",
  "Algolia.SearchPage.Filters.Label": "Filters",
  "Algolia.SearchPage.ClearButton.Label": "Clear all",
  "Algolia.SearchPage.ProgramType.Label": "Program Type",
  "Algolia.SearchPage.DeliveryMethod.Label": "Delivery method",
  "Algolia.SearchPage.HousingType.Label": "Housing Types",
  "Algolia.SearchPage.AcademicLevel.Label": "Academic Level",
  "Algolia.SearchPage.UniversityName.Label": "University Name",
  "Algolia.SearchPage.Select.Placeholder": "Start typing or select",
  "Algolia.SearchPage.UniversityRanking.Label": "University Ranking",
  "Algolia.SearchPage.AcademicDiscipline.Label": "Academic Discipline",
  "Algolia.SearchPage.Regions.Label": "Regions",
  "Algolia.SearchPage.SubregionsCities.Label": "Subregions & Cities",
  "Algolia.SearchPage.LanguageOfInstruction.Label": "Language of Instruction",
  "Algolia.SearchPage.languagePrerequisiteLevel.Label": "Language prerequisite level",
  "Algolia.SearchPage.GPARequirements.Label": "GPA Requirements",
  "Algolia.SearchPage.TermType.Label": "Term Type",
  "Algolia.SearchPage.ProgramFees.Label": "Program Fees",
  "Algolia.SearchPage.SearchButton.Title": "Search Programs",
  "Algolia.SearchPage.ResultsMeta": '{count} Program Results',
  "Algolia.SearchPage.SortBy.Label": "Sort By",
  "Algolia.SearchPage.SortBy.Relevancy.option": "Relevancy",
  "Algolia.SearchPage.SortBy.Newest.option": "Latest",
  "Algolia.SearchPage.CreditPrograms.Label": "Show only credit programs",
  "Algolia.SearchPage.HousingType.Tooltip": "Have a specific housing type in mind? Filter by housing type here.",
  "Algolia.SearchPage.languagePrerequisiteLevel.Tooltip": "Looking for programs suitable for your language level? Filter by language level here.",
  "Algolia.SearchPage.GPARequirements.Tooltip": "Looking for programs suitable for your academic record? Filter by GPA level here.",
  "Algolia.SearchPage.ProgramFees.Tooltip": "Have a budget in mind? Filter by cost here. Select more than one to broaden your search.",

  "Pager.Current.MetaCurrent": "Current page",
  "Pager.First.MetaFirst": "Go to first page",
  "Pager.Last.MetaLast": "Go to last page",
  "Pager.Next.MetaTitle": "Go to next page",
  "Pager.Next.TextFull": "Next page",
  "Pager.Next.Text": "Next",
  "Pager.Page.MetaPageNumber": "Go to page {page}",
  "Pager.Page.VisuallyHidden": "Page",
  "Pager.Previous.MetaTitle": "Go to previous page",
  "Pager.Previous.TextFull": "Previous page",
  "Pager.Previous.Text": "Prev",

  "ProgramCard.Label.None": "None",
  "ProgramCard.EstimatedCost.Label": "Estimated Cost",
  "ProgramCard.CTA.Label": "Program Details",
  "ProgramCard.GPARequirements.Label": "GPA Requirements",
  "ProgramCard.LanguageOfInstruction.Label": "Language of Instruction",
  "ProgramCard.LanguageRequirements.Label": "Language Requirements",
  "ProgramCard.Status.Label": "Program Suspended",

  "ProgramQuickView.Length.Label": "Length",
  "ProgramQuickView.Options.Label": "Delivery Method",
  "ProgramQuickView.ReadMore.CTA": "Read More",
  "ProgramQuickView.ProgramDetails.CTA": "See Program Details",
  "ProgramQuickView.ApplyNow.CTA": "Apply Now",
  "ProgramQuickView.AtGlance.Label": "At a Glance",
  "ProgramQuickView.LanguageInstruction.Label": "Language of Instruction",
  "ProgramQuickView.LanguageRequirements.Label": "Language Requirements",
  "ProgramQuickView.languagePrerequisiteLevel.Label": "Language Prerequisites Level",
  "ProgramQuickView.GPA.Label": "GPA Requirements",
  "ProgramQuickView.AcademicLevel.Label": "Academic Level",
  "ProgramQuickView.Credits.Label": "Credits",
  "ProgramQuickView.AcademicStrengths.Label": "Academic Strengths",
  "ProgramQuickView.Housing.Label": "Housing",
  "ProgramQuickView.Internship.Label": "Part-Time Internship (Optional)",
  "ProgramQuickView.Visa.Label": "Visa Required",

  "ProgramSelector.BlockTitle": "Find your perfect program!",
  "ProgramSelector.BlockDescription": "When choosing to study abroad are you looking for a destination, a university, or specific type of program?",
  "ProgramSelector.BlockLink": "Or Browse All Programs",
  "ProgramSelector.Destinations.BlockDescription": "Select the region you are most interested in",
  "ProgramSelector.Destinations.BlockQuestion": "Where do you want to study?",
  "ProgramSelector.Destinations.AllDestinations.Label": "All Destinations",
  "ProgramSelector.Destinations.Destinations.Label": "Destinations",
  "ProgramSelector.Universities.BlockDescription": "Select all universities that interest you",
  "ProgramSelector.Universities.BlockQuestion": "At what university do you want to study?",
  "ProgramSelector.Universities.Universities.Label": "Universities",
  "ProgramSelector.TypeOfStudy.TypeOfStudy.Label": "Type Of Study",
  "ProgramSelector.TypeOfStudy.BlockDescription": "Select all types of studies that interest you",
  "ProgramSelector.TypeOfStudy.BlockQuestion": "What types of programs would you like?",
  "ProgramSelector.SeePrograms.Label": "See my programs",
  "ProgramSelector.BrowsePrograms.Label": "or browse all programs",

  "Algolia.SidebarFilters.SelectOrRadios.FirstOption": "- Any -",
  "Algolia.SearchPage.GPARequirements.Options.None": "None",
}

export default messages;
